import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import getKnowledgeUrl from 'forms-utils-lib/urls/app/getKnowledgeUrl';
import { trackScreen } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnMoreLink = () => {
  const knowledgeBaseUrl = `${getKnowledgeUrl()}/articles/kcs_article/forms/create-forms`;
  return /*#__PURE__*/_jsx(UILink, {
    href: knowledgeBaseUrl,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.frameworkTable.empty.learnMore"
    })
  });
};
const PrimaryContent = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.frameworkTable.empty.introductionBodyWithPopups"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "dashboard.frameworkTable.empty.introductionCta",
      options: {
        learnMoreLink: /*#__PURE__*/_jsx(LearnMoreLink, {})
      }
    })
  })]
});
const ZeroState = () => {
  useEffect(() => {
    trackScreen('dashboard', 'zero-state');
    return () => void trackScreen('dashboard');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FORMS_DASHBOARD_ZERO_STATE",
    children: /*#__PURE__*/_jsx(UIEmptyState, {
      id: "forms-dashboard-zero-state",
      titleText: I18n.text('dashboard.frameworkTable.empty.introductionTitle'),
      primaryContent: /*#__PURE__*/_jsx(PrimaryContent, {}),
      secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
        name: "forms"
      }),
      secondaryContentWidth: 200
    })
  });
};
export default ZeroState;